import styled from 'styled-components';
import Container from 'react-bootstrap/Container';

export default styled(Container)`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
